module.exports = __webpack_public_path__ + "img/galileo_icon2.e81e9580.png";